<template>
  <div class="datepicker-trigger">
    <v-text-field :value="formatDates(dateOne, dateTwo)"
                  clearable
                  hide-details
                  color="labelColor"
                  id="datepicker-trigger"
                  :placeholder="t({s: 'toolbar.selectDates', component: 'Reports'})"
                  readonly
                  type="text"
    ></v-text-field>
    <AirbnbStyleDatepicker
        :closeAfterSelect="true"
        :date-one="dateOne"
        :date-two="dateTwo"
        :fullscreen-mobile="true" :mode="'range'"
        :showActionButtons="false"
        :showShortcutsMenuTrigger="false"
        :trigger-element-id="'datepicker-trigger'"
        :class="nightMode && 'airbnb-picker-dark'"
        @date-one-selected="val => { dateOne = val }"
        @date-two-selected="val => { dateTwo = val }"/>
  </div>
</template>

<style type="scss">
.airbnb-picker-dark *, .airbnb-picker-dark button {
  background: #272727;
  color: white;
  fill: white;
}
.asd__day--today {
  background: rgba(23, 60, 96, 0.75) !important;
  color: white !important;
}

</style>

<script lang="js">
import format from 'date-fns/format'
import { portalState } from '@/state'

export default {
  name: 'DatePicker',
  props: {
    dateRange: {
      required: false,
      type: Object,
      default: () => ({
        from: '',
        till: ''
      })
    }
  },
  computed: {
    nightMode () {
      return portalState.nightMode
    }
  },
  data: () => ({
    dateFormat: 'DD-MM-YYYY',
    dateOne: '',
    dateTwo: ''
  }),
  watch: {
    dateOne (value) {
      this.dateRange.from = value
      this.$emit('change', { from: value })
    },
    dateTwo (value) {
      this.dateRange.till = value
      this.$emit('change', { to: value })
    }
  },
  methods: {
    formatDates (dateOne, dateTwo) {
      let formattedDates = ''
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat)
      }
      if (dateTwo) {
        formattedDates += ' - ' + format(dateTwo, this.dateFormat)
      }
      if (dateOne.length > 1 && dateTwo.length > 1) {
        this.$emit('dates', {from: dateOne, to: dateTwo})
      }
      return formattedDates
    }
  }
}
</script>
